// extracted by mini-css-extract-plugin
export default {"navCont":"Navbar_navCont__NHo6h","title":"Navbar_title__r0sUj","linkCont":"Navbar_linkCont__H4Z-U","linkEl":"Navbar_linkEl__xY7nu","link":"Navbar_link__61lqP"};